export const init = () => {
  CUBE.Analytics.enhanced.spotlight.es6.initImpression();
};



// WEBPACK FOOTER //
// ./src/analytics/enhanced/ec-impression-spotlight.js